<template>
  <!-- A case study (S2_Proof): the problem, what we did, the result, with
       photos — three columns, or told as a story. -->
  <SectionBand :heading="section.heading || section.title" :variant="variant" :background="section.background" label="Case study">
    <div class="s2-case" :data-layout="section.layout === 'story' ? 'story' : 'three'">
      <div class="s2-case__parts mo-stagger">
        <div v-for="p in parts" :key="p.key" class="s2-case__part">
          <span class="t-eyebrow">{{ p.label }}</span>
          <div class="s2-prose t-body" v-html="html(p.text)" />
        </div>
      </div>
      <div v-if="photos.length" class="s2-case__photos" :data-count="Math.min(photos.length, 3)">
        <Media v-for="(img, i) in photos.slice(0, 3)" :key="i" :media="img" ratio="4 / 3" :caption="true" />
      </div>
    </div>
  </SectionBand>
</template>

<script setup>
import {computed} from "vue";
import SectionBand from "../shared/SectionBand.vue";
import Media from "../shared/Media.vue";
import {contentHtml} from "@/utils/contentHtml.js";
import {mediaList} from "@/utils/blocks.js";

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const parts = computed(() => [
  {key: "problem", label: "The problem", text: props.section.problem},
  {key: "solution", label: "What we did", text: props.section.what || props.section.solution},
  {key: "result", label: "The result", text: props.section.result},
].filter((p) => p.text));
const photos = computed(() => (Array.isArray(props.section.photos) ? props.section.photos : Array.isArray(props.section.images) ? props.section.images : []).filter((m) => mediaList([m]).length));
const html = (t) => contentHtml(t || "");
</script>

<style scoped>
.s2-case__parts { display: grid; gap: clamp(1rem, 3vw, 2rem); grid-template-columns: repeat(3, minmax(0, 1fr)); }
.s2-case[data-layout="story"] .s2-case__parts { grid-template-columns: 1fr; max-width: 46rem; }
.s2-case__part .t-eyebrow { display: block; margin-bottom: .4rem; }
.s2-case__photos { display: grid; gap: var(--t-gap); grid-template-columns: repeat(var(--n, 3), minmax(0, 1fr)); margin-top: clamp(1.25rem, 3vw, 2rem); }
.s2-case__photos[data-count="1"] { --n: 1; } .s2-case__photos[data-count="2"] { --n: 2; }
@media (max-width: 760px) { .s2-case__parts { grid-template-columns: 1fr; } .s2-case__photos { --n: 1 !important; } }
</style>
